import { Clock, CreditCard, Gift, MoreVertical, Truck } from "react-feather";
import { Btn, H6, Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service/DynamicImage";
import { Delete, Edit, Href } from "../../Constant";
import { OrderHistoryTableColumns, ProductDataTableProp } from "../../Type/EcommerceType";
import { Fragment } from "react";

export const BECOME_MEMBER_DATA = [
  {
    type: "Standard",
    price: 10,
    benefit: ["50GB Disk Space", "50 Email Accounts", "Maintenance", "15 Subdomains"],
  },
  {
    type: "Premium",
    price: 20,
    benefit: ["10% on all product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
  },
  {
    type: "Auther pack",
    price: 50,
    benefit: ["Upload 50 product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
  },
  {
    type: "Auther pack",
    price: 50,
    benefit: ["Upload 50 product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
  },
];

export const SIMPLE_PRICING_DATA = [
  {
    title: "Standard",
    price: 15,
    plan: "Standard Plan",
  },
  {
    title: "Business",
    price: 25,
    plan: "Business Plan",
  },
  {
    title: "Premium",
    price: 35,
    plan: "Premium Plan",
  },
  {
    title: "Extra",
    price: 45,
    plan: "Extra Plan",
  },
];

export const STAR_DATA = (
  <span>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star-half-o font-warning me-1"></i>
    <i className="fa fa-star-half-o font-warning"></i>
  </span>
);

export const STAR_DATAS = (
  <span>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning"></i>
  </span>
);

export const PRODUCT_SLIDE_1 = [
  {
    image: "01.jpg",
    title: "Woman T-shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "02.jpg",
    title: "Dream Beauty Fashion",
    text: "$150.00",
  },
  {
    image: "03.jpg",
    title: "Womens's Dress",
    text: "$200.00",
  },
];

export const PRODUCT_SLIDE_2 = [
  {
    image: "01.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "02.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "03.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
  },
];

export const FILTER_PRODUCT_DATA = [
  {
    id: 2,
    colClass: "col-xl-6 col-sm-6",
    filterData: ["1", "2"],
  },
  {
    id: 3,
    colClass: "col-xl-4 col-sm-4",
    filterData: ["3", "4", "5"],
  },
  {
    id: 4,
    colClass: "col-xl-3 col-md-4 col-sm-5",
    filterData: ["6", "7", "8", "9"],
  },
  {
    id: 6,
    colClass: "col-xl-2 col-md-4 col-sm-5",
    filterData: ["10", "11", "12", "13", "14", "15"],
  },
];

export const PRODUCT_SOCIAL = [
  {
    link: "https://www.facebook.com/",
    text: "facebook",
  },
  {
    link: "https://accounts.google.com/",
    text: "google-plus",
  },
  {
    link: "https://twitter.com/",
    text: "twitter",
  },
  {
    link: "https://www.instagram.com/",
    text: "instagram",
  },
  {
    link: "https://rss.app/",
    text: "rss",
  },
];

export const PRODUCT_BRAND_DATA = [
  {
    icon: <Truck />,
    text: "Free Shipping",
    span: "Free Shipping World Wide",
  },
  {
    icon: <Clock />,
    text: "24 X 7 Service",
    span: "Online Service For New Customer",
  },
  {
    icon: <Gift />,
    text: "Festival Offer",
    span: "New Online Special Festival",
  },
  {
    icon: <CreditCard />,
    text: "Online Payment",
    span: "Contrary To Popular Belief. ",
  },
];



const style2 = { width: 60, fontSize: 13, padding: 3 };

export const PRODUCT_DATA_TABLE = [
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-1.png")} />,
    details: (
      <Fragment>
        <H6> Red Shirt </H6>
        <span>Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt</span>
      </Fragment>
    ),
    amount: "$10",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-2.png")} />,
    details: (
      <Fragment>
        <H6>  Blue Shirt</H6>
        <span>Vida Loca - Blue Denim Fit Men's Casual Shirt.</span>
      </Fragment>
    ),
    amount: "$20",
    stock: <div className="font-primary">Low Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-3.png")} />,
    details: (
      <Fragment>
        <H6> Men Solid Denim Jacket </H6>
        <span>The Dry State - Blue Denim Regular Fit Men's Denim Jacket.</span>
      </Fragment>
    ),
    amount: "$12",
    stock: <div className="font-danger">out of Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-4.png")} />,
    details: (
      <Fragment>
        <H6> Cyclamen </H6>
        <span>Stylish co-ord Set 2 piece dress for women</span>
      </Fragment>
    ),
    amount: "$25",
    stock: <div className="font-primary">Low Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-5.png")} />,
    details: (
      <Fragment>
        <H6> Women shorts </H6>
        <span>Women Shorts Set</span>
      </Fragment>
    ),
    amount: "$23",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-6.png")} />,
    details: (
      <Fragment>
        <H6> Women Top </H6>
        <span>Women's Top</span>
      </Fragment>
    ),
    amount: "$18",
    stock: <div className="font-primary">Low Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-1.png")} />,
    details: (
      <Fragment>
        <H6> Red shirt </H6>
        <span>Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt.</span>
      </Fragment>
    ),
    amount: "$27",
    stock: <div className="font-danger">out of Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-2.png")} />,
    details: (
      <Fragment>
        <H6> Blue shirt </H6>
        <span>Vida Loca - Blue Denim Fit Men's Casual Shirt.</span>
      </Fragment>
    ),
    amount: "$23",
    stock: <div className="font-danger">out of Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-3.png")} />,
    details: (
      <Fragment>
        <H6> Men Solid Denim Jacket</H6>
        <span>The Dry State - Blue Denim Regular Fit Men's Denim Jacket.</span>
      </Fragment>
    ),
    amount: "$32",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
  {
    image: <Image className="p-1" src={dynamicImage("ecommerce/product-table-4.png")} />,
    details: (
      <Fragment>
        <H6> Cyclamen </H6>
        <span>Stylish co-ord Set 2 piece dress for women</span>
      </Fragment>
    ),
    amount: "$35",
    stock: <div className="font-danger">out of Stock</div>,
    start_date: "2023/04/25",
    action: (
      <div>
        <Btn style={style2} color="danger me-2" size="xs">
          {Delete}
        </Btn>
        <Btn style={style2} color="success" size="xs">
          {Edit}
        </Btn>
      </div>
    ),
  },
];

export const PRODUCT_DATA_TABLE_COLUMN = [
  {
    name: "Image",
    selector: (Row:ProductDataTableProp) => Row["image"],
    sortable: true,
    center: true,
  },
  {
    name: "Details",
    selector: (Row:ProductDataTableProp) => Row["details"],
    sortable: true,
    center: true,
  },
  {
    name: "Amount",
    selector: (Row:ProductDataTableProp) => Row["amount"],
    sortable: true,
    center: true,
  },
  {
    name: "Stock",
    selector: (Row:ProductDataTableProp) => Row["stock"],
    sortable: true,
    center: true,
  },
  {
    name: "Start date",
    selector: (Row:ProductDataTableProp) => Row["start_date"],
    sortable: true,
    center: true,
  },
  {
    name: "Action",
    selector: (Row:ProductDataTableProp) => Row["action"],
    sortable: true,
    center: true,
  },
];

export const CANCELLED_ORDER_DATA = [
  {
    id: 1,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 2,
    image: "product-table-5.png",
    title: "Women Shorts",
    price: 210,
  },
  {
    id: 3,
    image: "product-table-4.png",
    title: "Cyclamen",
    price: 210,
  },
  {
    id: 4,
    image: "product-table-3.png",
    title: "Men Solid Denim jacket",
    price: 210,
  },
  {
    id: 5,
    image: "product-table-2.png",
    title: "Blue shirt",
    price: 210,
  },
  {
    id: 6,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 7,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 8,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 9,
    image: "product-table-5.png",
    title: "Women shorts",
    price: 210,
  },
];

export const NEW_ORDER_DATA = [
  {
    id: 1,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 2,
    image: "product-table-5.png",
    title: "Women Shorts",
    price: 210,
  },
  {
    id: 3,
    image: "product-table-4.png",
    title: "Cyclamen",
    price: 210,
  },
  {
    id: 4,
    image: "product-table-3.png",
    title: "Men Solid Denim jacket",
    price: 210,
  },
  {
    id: 5,
    image: "product-table-2.png",
    title: "Blue shirt",
    price: 210,
  },
  {
    id: 6,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 7,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 8,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 9,
    image: "product-table-5.png",
    title: "Women shorts",
    price: 210,
  },
];

export const SHIPPED_ORDER_DATA = [
  {
    id: 1,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 2,
    image: "product-table-5.png",
    title: "Women Shorts",
    price: 210,
  },
  {
    id: 3,
    image: "product-table-4.png",
    title: "Cyclamen",
    price: 210,
  },
  {
    id: 4,
    image: "product-table-3.png",
    title: "Men Solid Denim jacket",
    price: 210,
  },
  {
    id: 5,
    image: "product-table-2.png",
    title: "Blue shirt",
    price: 210,
  },
  {
    id: 6,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 7,
    image: "product-table-1.png",
    title: "Red shirt",
    price: 210,
  },
  {
    id: 8,
    image: "product-table-6.png",
    title: "Women Top",
    price: 210,
  },
  {
    id: 9,
    image: "product-table-5.png",
    title: "Women shorts",
    price: 210,
  },
];

export const ORDER_HISTORY_DATA = [
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/1.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Long Top</a>
        <div className="order-process">
          <span className="order-process-circle"></span>Processing
        </div>
      </div>
    ),
    size: "M",
    color: "Lavander",
    articleNumber: 4215738,
    units: 1,
    price: "$14",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/13.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Fancy watch</a>
        <div className="order-process">
          <span className="order-process-circle"></span>Processing
        </div>
      </div>
    ),
    size: "35mm",
    color: "Blue",
    articleNumber: 5476182,
    units: 1,
    price: "$10",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/4.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Man Shoes</a>
        <div className="order-process">
          <span className="order-process-circle"></span>Processing
        </div>
      </div>
    ),
    size: "8",
    color: "Black & White",
    articleNumber: 1756457,
    units: 1,
    price: "$18",
    icon: <MoreVertical />,
  },

  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/10.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Ledis side bag</a>
        <div className="order-process">
          <span className="order-process-circle shipped-order"></span>Shipped
        </div>
      </div>
    ),
    size: "22cm x 18cm",
    color: "Brown",
    articleNumber: 7451725,
    units: 1,
    price: "$13",
    icon: <MoreVertical />,
  },

  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/12.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Ledis Slipper</a>
        <div className="order-process">
          <span className="order-process-circle shipped-order"></span>Shipped
        </div>
      </div>
    ),
    size: "6",
    color: "Brown & white",
    articleNumber: 4127421,
    units: 1,
    price: "$6",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/3.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Fancy ledis Jacket</a>
        <div className="order-process">
          <span className="order-process-circle shipped-order"></span>Shipped
        </div>
      </div>
    ),
    size: "XL",
    color: "Light gray",
    articleNumber: 3581714,
    units: 1,
    price: "$24",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/2.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Ledis Handbag</a>
        <div className="order-process">
          <span className="order-process-circle shipped-order"></span>Shipped
        </div>
      </div>
    ),
    size: "25cm x 20cm",
    color: "Black",
    articleNumber: 6748142,
    units: 1,
    price: "$14",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/15.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Iphone6 mobile</a>
        <div className="order-process">
          <span className="order-process-circle cancel-order"></span> Cancelled
        </div>
      </div>
    ),
    size: "10cm x 15cm",
    color: "Black",
    articleNumber: 5748214,
    units: 1,
    price: "$25",
    icon: <MoreVertical />,
  },
  {
    image: <Image className="img-fluid img-30" src={dynamicImage("product/14.png")} alt="#" />,
    productName: (
      <div className="product-name">
        <a href={Href}>Watch</a>
        <div className="order-process">
          <span className="order-process-circle cancel-order"></span>Cancelled
        </div>
      </div>
    ),
    size: "27mm",
    color: "Brown",
    articleNumber: 2471254,
    units: 1,
    price: "$12",
    icon: <MoreVertical />,
  },
];

export const ORDER_HISTORY_DATA_COLUMN = [
  {
    name: "Image",
    selector: (data: OrderHistoryTableColumns) => data["image"],
    sortable: true,
    center: true,
  },
  {
    name: "productName",
    selector: (Row: OrderHistoryTableColumns) => Row["productName"],
    sortable: true,
    center: true,
  },
  {
    name: "Size",
    selector: (Row: OrderHistoryTableColumns) => Row["size"],
    sortable: true,
    center: true,
  },
  {
    name: "Color",
    selector: (Row: OrderHistoryTableColumns) => Row["color"],
    sortable: true,
    center: true,
  },
  {
    name: "Article number",
    selector: (Row: OrderHistoryTableColumns) => Row["articleNumber"],
    sortable: true,
    center: true,
  },
  {
    name: "Units",
    selector: (Row: OrderHistoryTableColumns) => Row["units"],
    sortable: true,
    center: true,
  },
  {
    name: "Price",
    selector: (Row: OrderHistoryTableColumns) => Row["price"],
    sortable: true,
    center: true,
  },
  {
    name: <MoreVertical />,
    selector: (Row: OrderHistoryTableColumns) => Row["icon"],
    sortable: true,
    center: true,
  },
];
